import naja from 'naja';

export default class Checkbox {
    static init(): void {
        this.handleCheckboxes();

        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id === 'snippet-orderPersonForm-fields') {
                this.handleCheckboxes();
            }
        });
    }

    static handleCheckboxes(): void {
        const toggleArea = (checkbox: HTMLInputElement, area: HTMLElement): void => {
            if (checkbox.checked) {
                area.classList.remove('none');
            } else {
                area.classList.add('none');
            }

            if (area.classList.contains('none')) {
                this.handleRequiredInputsInsideArea(area, false);
            } else {
                this.handleRequiredInputsInsideArea(area, true);
            }
        };

        const checkboxes = document.querySelectorAll<HTMLInputElement>('.jsCheckbox');
        checkboxes.forEach((checkbox) => {
            const areaSelector = checkbox.dataset.area;
            if (!areaSelector) return;

            const area = document.querySelector<HTMLElement>(areaSelector);
            if (!area) return;

            toggleArea(checkbox, area);

            checkbox.removeEventListener('change', checkbox._checkboxHandler as EventListener);

            checkbox._checkboxHandler = (): void => {
                toggleArea(checkbox, area);
            };

            checkbox.addEventListener('change', checkbox._checkboxHandler as EventListener);
        });
    }

    static handleRequiredInputsInsideArea(area: HTMLElement, state: boolean): void {
        let mainClass = 'data-required';
        let subClass = 'dump-data-required';

        if (state) {
            mainClass = 'dump-data-required';
            subClass = 'data-required';
        } else {
            const errors = area.querySelectorAll('.form-container--error');
            errors.forEach((error) => {
                error.classList.remove('form-container--error');
            });
        }

        const requires = area.querySelectorAll(`[${mainClass}]`);
        requires.forEach((item) => {
            const value = item.getAttribute(mainClass);
            item.removeAttribute(mainClass);
            if (value) {
                item.setAttribute(subClass, value);
            }
        });
    }
}

declare global {
    interface HTMLInputElement {
        _checkboxHandler?: () => void;
    }
}
